import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const partnerInvoiceApi = createAsyncThunk(
  "partnerInvoice",
  async ({ month, year }) => {
    const params = {};
    if (month) {
      params.month = month;
    }
    if (year) {
      params.year = year;
    }
    const response = await axiosInstance.get(`/getPartnersWithTotalCommissions2`, { params });
    return response.data;
  }
);

const partnerInvoiceSlice = createSlice({
  name: "partnerInvoice",
  initialState: {
    partnerInvoice: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnerInvoiceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partnerInvoiceApi.fulfilled, (state, action) => {
        state.partnerInvoice = action.payload;
        state.loading = false;
      })
      .addCase(partnerInvoiceApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default partnerInvoiceSlice.reducer;
